import { createAsyncThunk } from '@reduxjs/toolkit'
import ViewStatistic from './view-statistic-model'
import {
  delete_viewStatistic,
  load_viewStatistics,
  store_viewStatistic,
} from './viewStatistic-service'

export const LoadViewStatisticsAsync = createAsyncThunk<any, any>(
  'composer/load/viewStatistic',
  async (params: { uid: string }) => {
    return await load_viewStatistics(params)
  },
)

export const CreateViewStatisticAsync = createAsyncThunk<any, any>(
  'composer/create/viewStatistic',
  async (params: ViewStatistic) => {
    return await store_viewStatistic(params)
  },
)

export const DeleteViewStatisticAsync = createAsyncThunk<any, any>(
  'composer/delete/viewStatistic',
  async (params) => {
    return await delete_viewStatistic(params)
  },
)
